// Autogenerated file
export const sourceTypesEnum = {
    Web: "Web",
    Enterprise: "Enterprise",
    Forwarding: "Forwarding",
    Exploitation: "Exploitation",
    Kontur: "Kontur",
    ExternalIntegration: "ExternalIntegration",
};
export const sourceTypes = [
    { label: "Web", value: "Web" },
    { label: "1C+Enterprise", value: "Enterprise" },
    { label: "Cargorun+Forwarding", value: "Forwarding" },
    { label: "Cargorun+Exploitation", value: "Exploitation" },
    { label: "Kontur", value: "Kontur" },
    { label: "Внешняя площадка", value: "ExternalIntegration" },
];
